import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue } from 'firebase/database';
// import Sidebar from './CEOSidebar';
import { 
    FaSearch, 
    FaFileExcel, 
    FaPrint, 
    FaCopy,
    FaExclamationTriangle,
    FaCalendarAlt,
    FaRegCalendarCheck
} from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';

const Ceoreportdatewiseinterstedworkreport = () => {
    const [loading, setLoading] = useState(true);
    const [works, setWorks] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDate, setSelectedDate] = useState('All');
    const [availableDates, setAvailableDates] = useState([]);
    const [debugInfo, setDebugInfo] = useState({ 
        worksFound: 0, 
        societyFound: 0, 
        engineerFound: 0,
        rawWorksKeys: [] 
    });
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        let worksData = null;
        let societyData = null;
        let engineerData = null;

        const checkAndProcess = () => {
            if (worksData !== null && societyData !== null && engineerData !== null) {
                try {
                    let flattenedWorks = [];
                    const foundDates = new Set();
                    
                    // UNIVERSAL FLATTENER: Handle both nested (by meeting) and flat structures
                    if (worksData && typeof worksData === 'object') {
                        Object.entries(worksData).forEach(([key, value]) => {
                            if (value && typeof value === 'object') {
                                if (value.workName || value.workNumber) {
                                    flattenedWorks.push({
                                        id: key,
                                        meetingNumber: 'Direct',
                                        workNumber: value.workNumber || '-',
                                        workName: value.workName || '-',
                                        taluka: value.taluka || '-',
                                        tenderAmount: value.tenderAmount || '0',
                                        sharedwork: value.sharedwork || '-',
                                        societyInterest: 0,
                                        engineerInterest: 0,
                                        totalInterest: 0,
                                        interestDates: []
                                    });
                                } else {
                                    Object.entries(value).forEach(([workId, workData]) => {
                                        if (workData && typeof workData === 'object') {
                                            flattenedWorks.push({
                                                id: workId,
                                                meetingNumber: key,
                                                workNumber: workData.workNumber || '-',
                                                workName: workData.workName || '-',
                                                taluka: workData.taluka || '-',
                                                tenderAmount: workData.tenderAmount || '0',
                                                sharedwork: workData.sharedwork || '-',
                                                societyInterest: 0,
                                                engineerInterest: 0,
                                                totalInterest: 0,
                                                interestDates: []
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }

                    // Count society interest and extract dates
                    Object.values(societyData).forEach(userData => {
                        if (userData.work_payment) {
                            Object.values(userData.work_payment).forEach(payment => {
                                // Extract date
                                const pDate = payment.date || '-';
                                if (pDate !== '-') foundDates.add(pDate);

                                if (payment.selectedWorks && Array.isArray(payment.selectedWorks)) {
                                    payment.selectedWorks.forEach(workStr => {
                                        const cleanWorkStr = String(workStr).trim();
                                        const workNum = cleanWorkStr.split(' - ')[0].trim();
                                        const matchIndex = flattenedWorks.findIndex(w => String(w.workNumber).trim() === workNum);
                                        
                                        if (matchIndex !== -1) {
                                            if (selectedDate === 'All' || pDate === selectedDate) {
                                                flattenedWorks[matchIndex].societyInterest += 1;
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    });

                    // Count engineer interest and extract dates
                    Object.values(engineerData).forEach(userData => {
                        if (userData.work_payment) {
                            Object.values(userData.work_payment).forEach(payment => {
                                // Extract date
                                const pDate = payment.date || '-';
                                if (pDate !== '-') foundDates.add(pDate);

                                if (payment.selectedWorks && Array.isArray(payment.selectedWorks)) {
                                    payment.selectedWorks.forEach(workStr => {
                                        const cleanWorkStr = String(workStr).trim();
                                        const workNum = cleanWorkStr.split(' - ')[0].trim();
                                        const matchIndex = flattenedWorks.findIndex(w => String(w.workNumber).trim() === workNum);
                                        
                                        if (matchIndex !== -1) {
                                            if (selectedDate === 'All' || pDate === selectedDate) {
                                                flattenedWorks[matchIndex].engineerInterest += 1;
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    });

                    // Final totals and filter only those with interest on the selected date
                    let processedWorks = flattenedWorks.map(w => ({
                        ...w,
                        totalInterest: w.societyInterest + w.engineerInterest
                    }));

                    if (selectedDate !== 'All') {
                        processedWorks = processedWorks.filter(w => w.totalInterest > 0);
                    }

                    setAvailableDates(Array.from(foundDates).sort().reverse());
                    setWorks(processedWorks);
                    setDebugInfo({ 
                        worksFound: processedWorks.length, 
                        societyFound: Object.keys(societyData).length, 
                        engineerFound: Object.keys(engineerData).length,
                        rawWorksKeys: Object.keys(worksData || {})
                    });
                    setLoading(false);
                } catch (error) {
                    console.error("Critical error in report processing:", error);
                    setLoading(false);
                }
            }
        };

        const unsubWorks = onValue(ref(db, 'ekamwatapzp/WorkNames'), (snapshot) => {
            worksData = snapshot.exists() ? snapshot.val() : {};
            checkAndProcess();
        }, (err) => { worksData = {}; checkAndProcess(); });

        const unsubSociety = onValue(ref(db, 'ekamwatapzp/SocietyRegistrations'), (snapshot) => {
            societyData = snapshot.exists() ? snapshot.val() : {};
            checkAndProcess();
        }, (err) => { societyData = {}; checkAndProcess(); });

        const unsubEngineer = onValue(ref(db, 'ekamwatapzp/EngineerRegistrations'), (snapshot) => {
            engineerData = snapshot.exists() ? snapshot.val() : {};
            checkAndProcess();
        }, (err) => { engineerData = {}; checkAndProcess(); });

        return () => {
            unsubscribeAuth();
            unsubWorks();
            unsubSociety();
            unsubEngineer();
        };
    }, [navigate, selectedDate]);

    const filteredWorks = works.filter(work => {
        const query = searchTerm.toLowerCase().trim();
        const matchesQuery = !query || 
               String(work.workNumber).toLowerCase().includes(query) || 
               String(work.workName).toLowerCase().includes(query) || 
               String(work.taluka).toLowerCase().includes(query) ||
               String(work.sharedwork).toLowerCase().includes(query);

        return matchesQuery && work.sharedwork === 'सुबे';
    });

    const exportToExcel = () => {
        const dataToExport = filteredWorks.map((w, index) => ({
            '#': index + 1,
            'वर्क नंबर': w.workNumber,
            'कामाचे नाव': w.workName,
            'तालुका': w.taluka,
            'कामाची रक्कम': w.tenderAmount,
            'कामाचा प्रकार': w.sharedwork,
            'मजूर संस्था पसंती': w.societyInterest,
            'इंजिनियर पसंती': w.engineerInterest,
            'एकूण पसंती': w.totalInterest
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Datewise Interested Works");
        XLSX.writeFile(wb, `Interest_Report_${selectedDate}_${new Date().toLocaleDateString()}.xlsx`);
    };

    const handlePrint = () => { window.print(); };

    const copyToClipboard = () => {
        const text = filteredWorks.map(w => `${w.workNumber}\t${w.workName}\t${w.taluka}\t${w.tenderAmount}\t${w.sharedwork}\t${w.totalInterest}`).join('\n');
        navigator.clipboard.writeText(text);
        alert('Data copied to clipboard!');
    };

    if (loading) {
        return (
            <div className="flex h-screen bg-gray-50">
              
                <div className="flex-1 flex flex-col items-center justify-center gap-4">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#267c77]"></div>
                    <p className="text-gray-500 font-bold animate-pulse">डेटा लोड होत आहे (Fetching for Date: {selectedDate}...)</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen bg-[#f4f7f6]">
         
            
            <main className="flex-1 p-4 md:p-8">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-black text-gray-800 tracking-tighter flex items-center gap-3">
                        <FaCalendarAlt className="text-[#267c77]" />
                        <span>तारखेनुसार इंटरेस्टेड वर्क रिपोर्ट (सुबे)</span>
                    </h1>
                    <div className="text-[10px] font-black text-gray-400 bg-white px-3 py-1.5 rounded-full border border-gray-100 shadow-sm uppercase tracking-widest">
                        {selectedDate === 'All' ? 'सर्व तारखा (All Dates)' : `तारीख: ${selectedDate}`}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                    {/* Date Selector */}
                    <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 flex items-center gap-4">
                        <div className="w-12 h-12 bg-indigo-50 rounded-2xl flex items-center justify-center text-indigo-600">
                            <FaRegCalendarCheck size={24} />
                        </div>
                        <div className="flex-1">
                            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">तारीख निवडा (Select Date)</label>
                            <select 
                                className="w-full bg-transparent font-bold text-gray-800 outline-none cursor-pointer"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            >
                                <option value="All">सर्व तारखा (Show All)</option>
                                {availableDates.map(date => (
                                    <option key={date} value={date}>{date}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 flex items-center gap-4">
                        <div className="w-12 h-12 bg-emerald-50 rounded-2xl flex items-center justify-center text-emerald-600">
                            <div className="text-xl font-black">{filteredWorks.length}</div>
                        </div>
                        <div>
                            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">एकूण कामे</label>
                            <div className="text-sm font-bold text-gray-800">पसंती मिळालेली कामे</div>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 flex items-center gap-4">
                        <div className="w-12 h-12 bg-orange-50 rounded-2xl flex items-center justify-center text-orange-600">
                            <div className="text-xl font-black">
                                {filteredWorks.reduce((acc, curr) => acc + curr.totalInterest, 0)}
                            </div>
                        </div>
                        <div>
                            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">एकूण पसंती</label>
                            <div className="text-sm font-bold text-gray-800">निवडलेल्या तारखेनुसार</div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-3xl shadow-2xl shadow-gray-200/50 border border-gray-200 overflow-hidden">
                    <div className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-6 bg-gradient-to-r from-gray-50/50 to-white border-b border-gray-100">
                        <div className="flex gap-2">
                            <button onClick={copyToClipboard} className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-xl hover:bg-gray-700 text-sm font-bold transition-all transform active:scale-95">
                                <FaCopy size={14} /> Copy
                            </button>
                            <button onClick={exportToExcel} className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 text-sm font-bold transition-all transform active:scale-95">
                                <FaFileExcel size={14} /> Excel
                            </button>
                            <button onClick={handlePrint} className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 text-sm font-bold transition-all transform active:scale-95">
                                <FaPrint size={14} /> Print
                            </button>
                        </div>

                        <div className="relative group min-w-[300px]">
                            <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#267c77] transition-colors" />
                            <input 
                                type="text" 
                                className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-2xl text-sm font-medium focus:ring-4 focus:ring-[#267c77]/10 focus:border-[#267c77] outline-none transition-all shadow-inner"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="वर्क नंबर, नाव, तालुका किंवा प्रकार..."
                            />
                        </div>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead>
                                <tr className="bg-gray-50 text-gray-600 text-[10px] font-black uppercase tracking-widest border-b border-gray-100">
                                    <th className="px-6 py-4 border-r border-gray-100 text-center w-20">#</th>
                                    <th className="px-6 py-4 border-r border-gray-100 w-40">वर्क नंबर</th>
                                    <th className="px-6 py-4 border-r border-gray-100 min-w-[300px]">कामाचे नाव</th>
                                    <th className="px-6 py-4 border-r border-gray-100 w-32">तालुका</th>
                                    <th className="px-6 py-4 border-r border-gray-100 w-32 text-right">रक्कम (Rs.)</th>
                                    <th className="px-6 py-4 border-r border-gray-100 w-32 text-center">कामाचा प्रकार</th>
                                    <th className="px-6 py-4 text-center w-32">पसंती ({selectedDate})</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {filteredWorks.length > 0 ? (
                                    filteredWorks.map((w, index) => (
                                        <tr key={w.id} className="hover:bg-blue-50/20 transition-all text-sm">
                                            <td className="px-6 py-5 border-r border-gray-50 text-center font-bold text-gray-400">{index + 1}</td>
                                            <td className="px-6 py-5 border-r border-gray-50 font-black text-blue-600">{w.workNumber}</td>
                                            <td className="px-6 py-5 border-r border-gray-50">
                                                <div className="font-bold text-gray-800 leading-tight">{w.workName}</div>
                                            </td>
                                            <td className="px-6 py-5 border-r border-gray-50 font-medium text-gray-600">{w.taluka}</td>
                                            <td className="px-6 py-5 border-r border-gray-50 text-right font-black text-gray-900">{w.tenderAmount}</td>
                                            <td className="px-6 py-5 border-r border-gray-50 text-center">
                                                <span className={`px-2 py-1 rounded text-[9px] font-black tracking-widest uppercase ${
                                                    w.sharedwork === 'सुबे' ? 'bg-indigo-50 text-indigo-600' : 
                                                    w.sharedwork === 'मजूर' ? 'bg-orange-50 text-orange-600' : 
                                                    'bg-gray-50 text-gray-400'
                                                }`}>
                                                    {w.sharedwork}
                                                </span>
                                            </td>
                                            <td className="px-6 py-5 text-center">
                                                <div className="flex flex-col items-center">
                                                    <span className="text-xl font-black text-[#267c77]">{w.totalInterest}</span>
                                                    <div className="flex gap-2 mt-1">
                                                        <span className="text-[9px] font-bold text-orange-400">M:{w.societyInterest}</span>
                                                        <span className="text-[9px] font-bold text-blue-400">E:{w.engineerInterest}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="px-6 py-24 text-center">
                                            <div className="max-w-md mx-auto flex flex-col items-center gap-6">
                                                <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center border-2 border-gray-100 animate-pulse">
                                                    <FaExclamationTriangle className="text-gray-200 text-4xl" />
                                                </div>
                                                <div>
                                                    <h3 className="text-xl font-black text-gray-800">माहिती सापडली नाही!</h3>
                                                    <p className="text-gray-400 text-sm mt-2 font-medium">निवडलेल्या तारखेस ({selectedDate}) कोणतीही पसंती मिळालेली नाही.</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-6 bg-gray-50 border-t border-gray-100 text-[10px] font-black text-gray-400 uppercase tracking-widest flex justify-between">
                        <span>ठाणे जिल्हा परिषद - {filteredWorks.length} नोंदी आढळल्या</span>
                        <div className="flex gap-4">
                            <span>S: {debugInfo.societyFound} Soc.</span>
                            <span>E: {debugInfo.engineerFound} Eng.</span>
                        </div>
                    </div>
                </div>
            </main>

            <style dangerouslySetInnerHTML={{ __html: `
                @media print {
                    aside { display: none !important; }
                    main { padding: 0 !important; margin: 0 !important; }
                    .rounded-3xl { border: none !important; box-shadow: none !important; }
                    button, .Search-box, select, .md\\:grid-cols-3 { display: none !important; }
                    table { width: 100% !important; border-collapse: collapse !important; border: 1.5px solid #333 !important; }
                    th, td { border: 1px solid #999 !important; padding: 12px 10px !important; color: #000 !important; }
                    th { background-color: #eee !important; font-weight: 900 !important; }
                }
            `}} />
        </div>
    );
};

export default Ceoreportdatewiseinterstedworkreport;
